import React, { useCallback, useState } from 'react';

import { ModalTransition } from '@atlaskit/modal-dialog';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Flex, xcss } from '@atlaskit/primitives';

import type { CardsActions } from '../../../../controllers/use-cards-extension-parameters-and-actions/types';
import type { CardsExtensionParameters, Filters } from '../../../../types';

import { DynamicCardsContent } from './dynamic-cards-content';
import { DynamicContentModal } from './dynamic-content-modal';
import { EmptyStateContainer } from './empty-state-container';

const disabledContentWrapperStyles = xcss({
	cursor: 'not-allowed',
});

type DynamicVariantContentProps = {
	extensionParameters: CardsExtensionParameters;
	extensionActions: CardsActions;
	isDisabled: boolean;
};

export const DynamicVariantContent = ({
	extensionParameters,
	extensionActions,
	isDisabled,
}: DynamicVariantContentProps) => {
	const { filters } = extensionParameters;
	const { updateMainFormField } = extensionActions;

	const hasFilters = !!filters;

	const [isDynamicContentModalOpen, setIsDynamicContentModalOpen] = useState(false);
	const handleCloseModal = useCallback(() => setIsDynamicContentModalOpen(false), []);
	const handleOpenModal = useCallback(() => setIsDynamicContentModalOpen(true), []);

	const handleSetFilters = (newFilters: Filters) => {
		updateMainFormField({ filters: newFilters });
	};

	return (
		<>
			<Flex direction="column" gap="space.300" xcss={[isDisabled && disabledContentWrapperStyles]}>
				{hasFilters ? (
					<DynamicCardsContent
						viewFilters={handleOpenModal}
						extensionParameters={extensionParameters}
						extensionActions={extensionActions}
					/>
				) : (
					<EmptyStateContainer startCreateFilters={handleOpenModal} />
				)}
			</Flex>
			<ModalTransition>
				{isDynamicContentModalOpen && (
					<DynamicContentModal
						filters={filters}
						closeModal={handleCloseModal}
						setFilters={handleSetFilters}
					/>
				)}
			</ModalTransition>
		</>
	);
};
